import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Building2, Compass, Home } from "lucide-react";
import { SEO } from "@/lib/seo";

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <section className="grid min-h-screen place-items-center bg-background px-4 py-16 ambient-grid">
      <SEO title={t("seo.notFound.title")} description={t("seo.notFound.description")} path={location.pathname} noindex />
      <div className="mx-auto max-w-md rounded-2xl border border-border bg-card p-8 text-center shadow-soft animate-fade-in">
        <div className="mx-auto mb-6 grid h-16 w-16 place-items-center rounded-full bg-primary/10 text-primary">
          <Compass className="h-8 w-8" aria-hidden="true" />
        </div>
        <p className="text-sm font-bold uppercase tracking-widest text-primary">{t("notFound.title")}</p>
        <h1 className="mt-2 text-3xl font-black">{t("notFound.message")}</h1>
        <p className="mt-3 text-sm text-muted-foreground" dir="ltr">
          <code className="rounded bg-muted px-2 py-0.5 text-xs">{location.pathname}</code>
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <a
            href="/"
            className="inline-flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-bold text-primary-foreground shadow-premium transition hover:scale-105"
          >
            <Home className="h-4 w-4" /> {t("notFound.back")}
          </a>
          <a
            href="/listings"
            className="inline-flex items-center gap-2 rounded-full border border-border px-5 py-2.5 text-sm font-bold transition hover:bg-secondary"
          >
            <Building2 className="h-4 w-4" /> {t("notFound.browse")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
